// Frameworks and Libraries Icons
import reactIcon from "../assets/react-icon.svg";
import reactNativeIcon from "../assets/react-native-icon.svg";
import djangoIcon from "../assets/django-icon.svg";
import angularIcon from "../assets/angular-icon.svg";
import ionicIcon from "../assets/ionic-icon.png";
import bootstrapIcon from "../assets/bootstrap-icon.svg";
import materialUIIcon from "../assets/material-ui-icon.svg";
import tailwindcssIcon from "../assets/tailwindcss-icon.svg";
import threejsIcon from "../assets/threejs-icon.svg";
import gsapIcon from "../assets/gsap-icon.svg";

// Programming Languages Icons
import pythonIcon from "../assets/python-icon.svg";
import javascriptIcon from "../assets/javascript-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import unixShellScriptIcon from "../assets/unix-shell-script-icon.png";
import javaIcon from "../assets/java-icon.svg";

// Programming Technologies Icons
import mySqlIcon from "../assets/mysql-icon.svg";
import sqlite3Icon from "../assets/sqlite3-icon.png";
import cloudComputingIcon from "../assets/cloud-computing-icon.png";
import dockerIcon from "../assets/docker-icon.svg";
import gitIcon from "../assets/git-icon.svg";
import postmanIcon from "../assets/postman-icon.png";

// Programming Methodologies Icons
import dsaIcon from "../assets/dsa-icon.png";
import oopsIcon from "../assets/oops-icon.png";
import seoIcon from "../assets/seo-icon.png";
import agileIcon from "../assets/agile-icon.png";

// Assign the object to a variable
const icons = {
  reactIcon,
  reactNativeIcon,
  djangoIcon,
  angularIcon,
  ionicIcon,
  bootstrapIcon,
  materialUIIcon,
  tailwindcssIcon,
  threejsIcon,
  gsapIcon,
  pythonIcon,
  javascriptIcon,
  typescriptIcon,
  unixShellScriptIcon,
  javaIcon,
  mySqlIcon,
  sqlite3Icon,
  cloudComputingIcon,
  dockerIcon,
  gitIcon,
  postmanIcon,
  dsaIcon,
  oopsIcon,
  seoIcon,
  agileIcon,
};

// Export the variable as the default export
export default icons;
